import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login/Login";
import AppLayout from "./components/Layout/AppLayout";
import Dashboard from "./components/Dashboard/Dashboard";
import ChatApp from "./components/Chat/ChatApp";
import Orders from "./components/Orders/Orders";
import TestMessages from "./components/Test/TestMessages";
import { chat } from "./services/api";
import "./styles/chat.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const session = localStorage.getItem("capizflow_session");
    if (session) setIsLoggedIn(true);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!isLoggedIn) return;
    const pollUnread = async () => {
      try {
        const data = await chat.getConversations();
        setUnreadCount(data.unread || 0);
      } catch (err) {}
    };
    pollUnread();
    const interval = setInterval(pollUnread, 5000);
    return () => clearInterval(interval);
  }, [isLoggedIn]);

  const handleLogin = (username) => {
    localStorage.setItem("capizflow_session", JSON.stringify({ username }));
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("capizflow_session");
    setIsLoggedIn(false);
  };

  if (loading) return null;

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={isLoggedIn ? <Navigate to="/" /> : <Login onLogin={handleLogin} />}
        />
        <Route
          path="/*"
          element={
            isLoggedIn ? (
              <AppLayout onLogout={handleLogout} unreadCount={unreadCount}>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/chat" element={<ChatApp onLogout={handleLogout} />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/test" element={<TestMessages />} />
                </Routes>
              </AppLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
